import "./CheckIn.css";
import { React, useState, useEffect ,useImperativeHandle, forwardRef} from "react";
import DatePicker from 'react-multi-date-picker';
import OutlinedInput from '@mui/material/OutlinedInput';
import ButtonGroup from '@mui/material/ButtonGroup';
import Button from '@mui/material/Button';
import { apiMain } from "../../App";
// import { IconCalender } from '../images/IconCalender';
import { useSnackbar } from "notistack";
import { useParams } from 'react-router-dom';
import { GetDataPromise, PostDataPromise } from "../Functions/SendingData";
import Box from '@mui/material/Box';
import {  IconButton, fabClasses } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
// import ico2 from "../images/ExitIcon.png"
import { Snackbar, Alert} from "@mui/material";
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import LoadingOverlay  from "../LoadingOverlay";
import gregorian from "react-date-object/calendars/gregorian";
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import { Loading } from "../Loading";
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
//import { Alert, Box, Backdrop } from "@mui/material";
import HotelVoucher_Pdf from "../reports/HotelVoucher_Pdf";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { fontSize, width } from "@mui/system";
import { TruckElectric } from "lucide-react";

// import ReactDOM from "react-dom";
const Reservation=forwardRef((props,ref)=> {
  const [value, setValue] = useState('1');
  //  const childref = useRef();
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useImperativeHandle(ref, () => ({
    add: sendUpdate,
    edit: SetEdit,
    voucher:  getRoomVoucher,
    new: handleReset,
    changerom:ChangeRoom,
  }));
  const [RoomTypeData, setRoomTypeData] = useState([]);
  const [Dayind, setDayind] = useState([]);
  const [Day, setDay] = useState([]);
  const [Mont, setMont] = useState([]);
  const [colr, setcolr] = useState([]);
  const [Addflag, setAddflag] = useState(false);
  const [rescheckinflag ,setResCheckInFlag]= useState(false);
  const [Editflag, setEditFlag] = useState(false);
  const [DataView, setDataView] = useState([]);
  const [imgURL, setImgURL] = useState(null);
  const [data, setData] = useState();
  const [Room_Number, setRoom_Number] = useState();
  const [changeroomflag, setChangeRoomFlag] = useState(0);
  const [error, setError] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [dialogLoading, setDialogLoading] = useState(false);
  const [dialogError, setDialogError] = useState({});
  const [Pass_Id, setPass_Id] = useState(0);
  const [Pass_FName, setPass_FName] = useState("");
  const [Pass_LName, setPass_LName] = useState("");
  const [Pass_Email, setPass_Email] = useState("");
  const [Pass_No, setPass_No] = useState("");
  const [Pass_PhonNo, setPass_PhonNo] = useState("");
  const [Reserv_Checkindate, setReserv_Checkindate] = useState(new Date());
  const [ChangeRoom_Checkindate, setChangeRoom_Checkindate] = useState(new Date());
  const [Reserv_Checkoutdate, setReserv_Checkoutdate] = useState(new Date());
  const [Checkindate_Old, setCheckindate_Old] = useState(new Date());
  const [Checkoutdate_Old, setCheckoutdate_Old] = useState(new Date());
  const [Prese_Id, setPrese_Id] = useState(0);
  const [Adults_No, setAdults_No] = useState(0);
  const [Childern_No, setChildern_No] = useState(0);
  const [Nights_No, setNights_No] = useState(0);
  const [Room_No, setRoom_No] = useState(0);
  const [loading, setLoading] = useState(false);
  const [RoomVoucher, setRoomVoucher] = useState(false);
  const [Reserv_Price, setReserv_Price] = useState(0);
  const [Arze_Name, setArze_Name] = useState('');
  const [Base_Price, setBase_Price] = useState(0);
  const [Reserv_prepayment, setReserv_prepayment] = useState(0);
  const [Reserv_gelprepayment, setReserv_Gelprepayment] = useState(0);
  const [Reserv_other, setReserv_other] = useState(0);
  const [Reserv_gelother, setReserv_Gelother] = useState(0);
  const [Reserv_total, setReserv_total] = useState(0);
  const [Reserv_Account, setReserv_Account] = useState(0);
  const [Reserv_DebitBalance, setReserv_DebitBalance] = useState(0);
  const [Reserv_prepaymenReserv, setReserv_prepaymenReserv] = useState(0);
  const [Reserv_GelprepaymenReserv, setReserv_GelprepaymenReserv] = useState(0);
   const [Reserv_GelPenalty, setReserv_GelPenalty] = useState(0);
  const [Reserv_Rate, setReserv_Rate] = useState(0);
  const [Reserv_Gel, setReserv_Gel] = useState(0);
  const [Reserv_Discount, setReserv_Discount] = useState(0);
  const [Reserv_GelDiscount, setReserv_GelDiscount] = useState(0);
  const [Reserv_Cancel, setReserv_Cancel] = useState(0);
  const [Reserv_Id, setReserv_Id] = useState(0);
  const [Reserv_Extrabed, setReserv_Extrabed] = useState(0);
  const [Reserv_ExtraAmount, setReserv_ExtraAmount] = useState(0);
  const [Reserv_Breakfast, setReserv_Breakfast] = useState(0);
  const [Reserv_BreakfastAmount, setReserv_BreakfastAmount] = useState(0);
  const [EnaDisa, SetEnaDisa] = useState("");
  const [EnaDisacheckin, SetEnaDisacheckin] = useState("");
  const [inouttype, setinouttype] = useState(false);
  const [txtMessage , settxtMessage]=useState("");
  const [alertType , setalertType]=useState(0);
  const [openPDF, setOpenPDF] = useState(false);
  const isPDF = typeof imgURL === "string" && imgURL.toLowerCase().endsWith(".pdf");
  const [ChangeRoom_No, setChangeRoom_No] = useState(0);
  const changeRoom_No = (event) => {
     setChangeRoom_No(event.target.value);
   };
  // const isPDF = imgURL?.toLowerCase().endsWith(".pdf");
  let mytoday = new Date();
  let MontMont = [];
  let colrcolr = [];
  useEffect(() => {
    getDay(new Date());
    getShowData();
    getRoomType();
    if (props.Reserv_Type ===2)
    {
      setResCheckInFlag(true)
    }
    if (props.permission.length > 0) {
      setAddflag(props.permission[0].Per_Add)
      setEditFlag(props.permission[0].Per_Edit)

    }

  }, [])
  useEffect(() => {
    getShowData();
  }, [props.Reserv_Id])

  // useEffect(() => {
  //   console.log('5555555555')
  //   getMyData(mytoday);
  // }, [Day])
  useEffect(() => {
    getPresentType();
  }, [])
  useEffect(() => {
    setReserv_Account(
      Number(Reserv_Price) +
      Number(Reserv_BreakfastAmount) * Number(Nights_No) +
      Number(Reserv_other) +
      Number(Reserv_ExtraAmount) * Number(Nights_No) -
      Number(Reserv_Discount) 
     );
     setReserv_DebitBalance(
      Number(Reserv_Price) +
      Number(Reserv_BreakfastAmount) * Number(Nights_No) +
      Number(Reserv_other) +
      Number(Reserv_ExtraAmount) * Number(Nights_No) -
      Number(Reserv_Discount) 
      // -      Number(Reserv_prepayment)
     );
    setReserv_total(
      Number(Reserv_Price) +
      Number(Reserv_BreakfastAmount) * Number(Nights_No) +
      Number(Reserv_other) +
      Number(Reserv_ExtraAmount) * Number(Nights_No) -
      Number(Reserv_Discount) -
      Number(Reserv_prepaymenReserv)
    
    // - Number(Reserv_prepayment)
    );
  }, [
    Reserv_Price,
    Reserv_BreakfastAmount,
    Reserv_ExtraAmount,
    Reserv_Discount,
    Reserv_prepayment,
    Reserv_other,
    Reserv_prepaymenReserv,
    Reserv_Rate,
  ]);
  const getRoomType = async () => {
    let res = await GetDataPromise(`${apiMain}/api/v1/room`, true);
    let parsed = JSON.parse(res);
    if ((parsed.status && parsed.status !== "error") || parsed.status === "success") {
      let newData = parsed.data;
      setRoomTypeData(newData)
    }

  }
  const getcompanion = async (e) => {
    let uparams = new URLSearchParams();

    uparams.append("Pass_Id", e);
    let res = await GetDataPromise(`${apiMain}/api/v1/compan/select?${uparams}`, false);
    let parsed = JSON.parse(res);

    if (parsed.data.length > 0) {
      setCompanion(Companion.map(com => (1 === com.id) ?
        {
          ...com, fname: parsed.data[0].Com_FName,
          lname: parsed.data[0].Com_LName, pass: parsed.data[0].Com_Pass_No
        }
        : com
      ));

      for (let index = 1; index < parsed.data.length; index++) {
        Companion.push({
          id: index + 1, fname: parsed.data[index].Com_FName,
          lname: parsed.data[index].Com_LName, pass: parsed.data[index].Com_Pass_No
        });
      }


    }


    //   setCompanion(parsed)
  }
  const getShowData = async () => {
    let uparams = new URLSearchParams();
    uparams.append("Reserv_Id", localStorage.getItem('Reserv_Id'));

    let res = await GetDataPromise(`${apiMain}/api/v1/reservation/selectreservid?${uparams}`, true);

    // let res = await GetDataPromise(`${apiMain}/api/v1/reservation`, force);
    let parsed = JSON.parse(res);

    if ((parsed.status && parsed.status !== "error") || parsed.status === "success") {
      let newData = parsed.data;
      setDataView(newData)
      setPass_Id(newData[0].Pass_Id)
      allitemupdate(newData[0])
    }
    setLoading(false)

  }


  const roomRate = async (temp, presed_id) => {

    let uparams = new URLSearchParams();
    let day = 0;
    let mon = 0;
    var dat = new Date(Reserv_Checkindate);
    let room_no = props.Room_No; //localStorage.getItem('Room_Number') ;
    /// let rtype_id =props.rtype_id

    day = dat.getDate();
    mon = dat.getMonth() + 1;
    let indate = dat.getFullYear() + '-' + mon + '-' + day;

    uparams.append("az_date", indate);
    //  uparams.append("Room_No", room_no);

    uparams.append("Arze_Id", 1);
    if (presed_id>3 )
    {
          uparams.append("Prese_Id", 3);
    }
    else
    {
          uparams.append("Prese_Id", presed_id);
    }

    let res = await GetDataPromise(`${apiMain}/api/v1/roomfee/selectfee?${uparams}`, false);
    let parsed = JSON.parse(res);
    if (parsed.data.length > 0) {
      let uparams2 = new URLSearchParams();
      uparams2.append("Room_No", props.Room_No);

      let res2 = await GetDataPromise(`${apiMain}/api/v1/room/select?${uparams2}`, false);
      let parsed2 = JSON.parse(res2);

      if (parsed2.data.length >0){
 
        setBase_Price(parsed.data[0][ parsed2.data[0].Room_Name ]);

      setReserv_Price(parsed.data[0][ parsed2.data[0].Room_Name] * temp)
      setArze_Name(parsed.data[0].Arze_Name)

      setReserv_Account((parsed.data[0][ parsed2.data[0].Room_Name]  * temp) - Reserv_prepayment)
      }
    }
    else {
      // alert('The price is not specified for this date range. No reservation is possible.')
      setReserv_Price(0)
      setReserv_Account((0) - Reserv_prepayment)
    }

  }
  const getDay = (today) => {
    const months = [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];
    //  let today = new Date();
    setDay([]);
    setDayind([]);
    setMont([]);
    setcolr([]);
    colrcolr = [];
    MontMont = [];
    for (let i = 0; i < 30; i++) {
      let day = 0;
      let mon = 0;
      i === 0 ? today.setDate(today.getDate()) : today.setDate(today.getDate() + 1);
      //  today.setDate( today.getDate()+ 1 );
      day = today.getDate();
      mon = today.getMonth() + 1;
      setDayind(prev => [...prev, day]);
      setDay(prev => [...prev, day + ' / ' + months[mon - 1]]);
      //  setMont(prev => [...prev, mon]);
      setMont(prev => [...prev, today.getFullYear() + '-' + day + '-' + mon]);
      MontMont[i] = today.getFullYear() + '-' + day + '-' + mon;

      setcolr(prev => [...prev, '#A6D9EF']);
      colrcolr[i] = '#A6D9EF'
    }

  }
  const getMyData = async (tar) => {
    let uparams = new URLSearchParams();
    let today = tar
    let mon = 0;
    setLoading(true);
    mon = today.getMonth();
    mon = mon + 1;
    let indate = today.getFullYear() + '-' + mon + '-' + today.getDate();
    today.setDate(today.getDate() + 30);
    mon = today.getMonth();
    mon = mon + 1;
    let outdate = today.getFullYear() + '-' + mon + '-' + today.getDate();
    uparams.append("Room_Number", props.Room_No);
    //localStorage.getItem("Room_Number")
    uparams.append("Checkindate", indate);
    uparams.append("Checkoutdate", outdate);
    let res = await GetDataPromise(`${apiMain}/api/v1/reservation/selectday?${uparams}`, true);
    let parsed = JSON.parse(res);
    let azdate = new Date();
    let tadate = new Date();

    if ((parsed.status && parsed.status !== "error") || parsed.status === "success") {
      let newData = parsed.data;
      setData(prev => {
        return {
          ...prev,
          attr: newData
        }
      })

    // let az = 0;
    // let ta = 0;
    // let azmon = 0;
    // let tamon = 0;
    //  let i = 0;
      let inday = new Date();
      let temp = colrcolr;
      newData.map((nd) => {
       azdate = new Date(nd['Reserv_Checkindate'])
       tadate = new Date(nd['Reserv_Checkoutdate'])

    let    az = azdate.getDate()
     let   ta = tadate.getDate()
     let    azmon = azdate.getMonth() + 1
    let     tamon = tadate.getMonth() + 1
        // console.log('ta=',  Math.floor((azdate - tadate) / (1000 * 60 * 60 * 24)))
        for (var dayy = azdate; dayy <= tadate; dayy.setDate(dayy.getDate() + 1)) {
          // your day is here
          //    console.log(day)
          // }
          //   for (let i = az; i <= ta; i++)
          let day = 0;
          let mon = 0;
          //  today.setDate( today.getDate()+ 1 );
          day = dayy.getDate();
          mon = dayy.getMonth() + 1;
          //   i=day.getDate()
          //      alert(Dayind.indexOf(i))
          azmon = dayy.getMonth() + 1
          tamon = dayy.getMonth() + 1
          inday = dayy.getFullYear() + '-' + day + '-' + mon

          //   alert(Mont.indexOf(inday))///////////////////
          // console.log(Mont[Dayind.indexOf(i)])  
          // setcolr(prev => {
          //  temp = prev
          //   if ((Mont[Dayind.indexOf(i)] === azmon || Mont[Dayind.indexOf(i)] === tamon) && Dayind.indexOf(i)===i) {
          //  console.log(inday )
          //  console.log(MontMont[MontMont.indexOf(inday)])
          if (MontMont[MontMont.indexOf(inday)] === (inday)) {
            console.log(nd['Reserv_Type'])
            if (nd['Reserv_Type'] === 1) {
              //  temp[Dayind.indexOf(i)] = '#F2595C'
              temp[MontMont.indexOf(inday)] = '#F4F754'

            }
            else {
              if (nd['Reserv_Type'] === 2) {
                temp[MontMont.indexOf(inday)] = '#F2595C'
              }
              else {
             //   temp[MontMont.indexOf(inday)]= '#F2595C'
            //    temp[MontMont.indexOf(inday)] = '#A6D9EF'
                console.log(nd['Reserv_Type'])

              }
            }
          }
          else {
            temp[MontMont.indexOf(inday)] = '#5F8C5F'

          }


           <Loading small={true} /> 
          //   return temp;
          // })
        };
      })
      setcolr(temp)
    }

    setLoading(false);

  }
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };
  // const params = useParams()
  // const [Rtype_Id, setRtype_Id  ]=useState(0);
  const listItems = [];
  const [Companion, setCompanion] = useState([
    { id: 1, fname: '', lname: '', pass: '' }
  ]);
  // const [image, setImage] = useState(null);

  const [PresentTypeData, setPresentTypeData] = useState([]);
  const changeCom_Fname = (event) => {

    if (parseInt(event.target.id) > Companion.length) {

      let myid = parseInt(event.target.id)
      Companion.push({ id: myid });
    }
    setCompanion(Companion.map(com =>
      parseInt(event.target.id) === com.id ? { ...com, fname: event.target.value } : com
      // com.id === event.target.id ? { ...com, fname: event.target.value } : com
    ));

  };
  const changeCom_Lname = (event) => {

    setCompanion(Companion.map(com =>
      parseInt(event.target.id) === com.id ? { ...com, lname: event.target.value } : com
    ));

  };
  const changeCom_Pass_No = (event) => {

    setCompanion(Companion.map(com =>
      parseInt(event.target.id) === com.id ? { ...com, pass: event.target.value } : com
    ));
  };
  const getPresentType = async () => {
    let res = await GetDataPromise(`${apiMain}/api/v1/presents`, true);
    let parsed = JSON.parse(res);
    if ((parsed.status && parsed.status !== "error") || parsed.status === "success") {
      let newData = parsed.data;
      setPresentTypeData(newData)

    }

  }
  // const changeExtraBed = (e) => {
  //   if (e.target.checked) {
  //     setReserv_Extrabed(1)
  //   }
  //   else {
  //     setReserv_Extrabed(0)
  //   }


  // }
  // const changeBreakFast = (e) => {
  //   if (e.target.checked) {
  //     setReserv_Breakfast(1)
  //   }
  //   else {
  //     setReserv_Breakfast(0)
  //   }


  // }
  const changeExtraAmount = (e) => {
    setReserv_ExtraAmount(e.target.value)
    
  }
  const getRoomVoucher = (e) => {
    setRoomVoucher(true)
    
  }
  const changeBreakfastAmount = (e) => {
        setReserv_BreakfastAmount(e.target.value)

  }
  const changePeres_Id = (event) => {
    setPrese_Id(event.target.value);
    roomRate(Nights_No, event.target.value);
  };
  // const changeReserv_Prepaymeny = (event) => {
  //   setReserv_prepayment(event.target.value)
    
  // //  setReserv_Account(Reserv_Price - event.target.value)
  // }
  const changeReserv_Other = (event) => {
    setReserv_other(event.target.value)
    setReserv_Gelother((event.target.value* Reserv_Rate).toFixed(2))
    
  //  setReserv_Account(Reserv_Price - event.target.value)
  }
  const changeReserv_GelOther = (event) => {

    setReserv_Gelother(event.target.value)
    if (Reserv_Rate !==0)
    {
      setReserv_other((event.target.value/ Reserv_Rate).toFixed(0))
    }
  //  setReserv_Account(Reserv_Price - event.target.value)
  }
  // const changeReserv_Total = (event) => {
  //   setReserv_total(event.target.value)
    
  // //  setReserv_Account(Reserv_Price - event.target.value)
  // }
  const changeReserv_Discount= (event) => {
     setReserv_Discount(event.target.value)
     setReserv_GelDiscount((event.target.value* Reserv_Rate).toFixed(2))
    }
  
    const changeReserv_GelDiscount= (event) => {
      setReserv_GelDiscount(event.target.value)
      if (Reserv_Rate !==0)
      {
        setReserv_Discount((event.target.value/ Reserv_Rate).toFixed(0))
      }
     }
     
     const changeReserv_prepaymenReserv= (event) => {
      setReserv_prepaymenReserv(event.target.value)
      setReserv_GelprepaymenReserv((event.target.value * Reserv_Rate).toFixed(2))
     }
   
     const changeReserv_GelprepaymenReserv= (event) => {
      setReserv_GelprepaymenReserv(event.target.value)
       if (Reserv_Rate !==0)
       {
        setReserv_prepaymenReserv((event.target.value/ Reserv_Rate).toFixed(0))
       }
      }
  const changeReserv_prepayment= (event) => {
    setReserv_prepayment(event.target.value)
    setReserv_Gelprepayment((event.target.value* Reserv_Rate).toFixed(2))


 }
 const changeReserv_Gelprepayment= (event) => {
  setReserv_Gelprepayment(event.target.value)
  if (Reserv_Rate !==0)
  {
    setReserv_prepayment((event.target.value/ Reserv_Rate).toFixed(0))
  }

}
  const changeReserv_Rate= (event) => {
    setReserv_Rate(event.target.value)

    setReserv_Gel(Reserv_Account * event.target.value)
   // setReserv_GelBreakfastAm(Reserv_BreakfastAmount * event.target.value)
  //  setReserv_GelExtraAmount(Reserv_ExtraAmount * event.target.value)
    setReserv_Gelother(Reserv_other * event.target.value)
    setReserv_GelDiscount(Reserv_Discount * event.target.value)
   setReserv_Gelprepayment(Reserv_prepayment * event.target.value)
  //  setReserv_GelDebitBalance(Reserv_DebitBalance * event.target.value)
    setReserv_GelprepaymenReserv(Reserv_prepaymenReserv * event.target.value)
 //   setReserv_Geltotal(Reserv_total * event.target.value)



 }

  function setclosevoucher(e) {
    setRoomVoucher(e)
  };
  const SetVoucher = () => {
    return (
      <Dialog
        open={RoomVoucher}
        onClose={() => setclosevoucher(false)}
        PaperProps={{
          sx: {
            maxWidth: 950,
            maxHeight: 650,
            width: 950,
            height: 900,
            backgroundColor: '#F2F2F2'
          },
          component: 'div',
        }}
      >
        <DialogTitle>Voucher</DialogTitle>
        <DialogContent>
          <DialogContentText>

          </DialogContentText>
          <HotelVoucher_Pdf Room_No={Room_Number} pass_id={Pass_Id}  />
          {/* datas={DataView}  Pass_Id={Pass_Id} */}
        </DialogContent>
        <DialogActions    >
          <Stack direction="row" spacing={1} style={{ paddingRight: '400px' }}>
            <Chip label="Exit" color="primary" onClick={() => setclosevoucher(false)} sx={{ width: 150, cursor: 'pointer' }} />
          </Stack>


        </DialogActions>
      </Dialog>
    )
  }
  const onChangeHandler = event => {

    // console.log(event.target.files[0])
 
    setImgURL(event.target.files[0])

  }
  function onchangeCheckoutdate(e) {
    setReserv_Checkoutdate(e)
    let az = new Date(Reserv_Checkindate);
    let ta = new Date(e);
    let Difference_In_Days = Math.floor((ta - az) / (1000 * 60 * 60 * 24));
    //alert(ta.getDate())
    setNights_No(Difference_In_Days)
    roomRate(Difference_In_Days, Prese_Id);
  }
  // function handleClosereservation() {
  //   props.ChangeXpage(0)
  // }
  function SetEdit() {
    SetEnaDisa("")

    if (!inouttype) {
      SetEnaDisacheckin("")
    }
  }
  const sendUpdate = async (e) => {
  //  e.preventDefault()
 //  setLoading(true)
 if (Base_Price ===0  &&   !Reserv_Cancel)
 {
  alert('The price is not specified for this date range. No reservation is possible.')
 }
    let flag =true;
    let formdata = new FormData();
    let uparams = new URLSearchParams();
    let formuser = new FormData();
    let formFiledata = new FormData();
    let formdata_reserv = new FormData();
    let azdate = new Date(Reserv_Checkindate);
    let tadate = new Date(Reserv_Checkoutdate);
    let azdatestr = new Date();
    let tadatestr = new Date();
    azdatestr = Date.parse(Reserv_Checkindate)
    //  let keys = Object.keys(data);
    // let errors = {};
    let azmon = 0;
    let tamon = 0;
    if (
      !Pass_FName ||
      !Pass_LName ||
      !Pass_No ||
      !Pass_Email
    ) {
      settxtMessage("  Please fill in all required fields.")
      setError(true);
      return;
    }

    azmon = azdate.getMonth();
    azmon = azmon + 1;
    tamon = tadate.getMonth();
    tamon = tamon + 1;
    azdatestr = azdate.getFullYear() + '-' + azmon + '-' + azdate.getDate();

    tadatestr = tadate.getFullYear() + '-' + tamon + '-' + tadate.getDate();
    if (Reserv_Cancel)
    { formdata_reserv.append("Reserv_Type", 4);
  setReserv_Price(0);
  setReserv_prepayment(0);
  setReserv_Account(0);
  setReserv_ExtraAmount(0);
  setReserv_BreakfastAmount(0);
  setReserv_Discount(0);
  setReserv_other(0);
  setReserv_Gel(0);
  setReserv_total(0);
  setBase_Price(0);

  }
     else
  { formdata_reserv.append("Reserv_Type", props.Reserv_Type);}

    // setPass_Id(0);
    formFiledata.append("Pass_Id", Pass_Id);
    formFiledata.append("Reserv_UrlFile", imgURL);
    formdata.append("Pass_Id", Pass_Id);
    formdata.append("Pass_FName", Pass_FName);
    formdata.append("Pass_LName", Pass_LName);
    formdata.append("Pass_No", Pass_No);
    formdata.append("Pass_Email", Pass_Email);
    formdata.append("Pass_PhonNo", Pass_PhonNo);
    // formdata.append("Reserv_UrlFile", imgURL);
    formdata_reserv.append("Reserv_Id", Reserv_Id);
    formdata_reserv.append("Pass_Id", Pass_Id);
    formdata_reserv.append("Room_Number", localStorage.getItem("Room_Number"));
    formdata_reserv.append("Reserv_Checkindate", azdatestr);
    formdata_reserv.append("Reserv_Checkoutdate", tadatestr);
    formdata_reserv.append("Adults_No", Adults_No);
    formdata_reserv.append("Night_No", Nights_No);
    formdata_reserv.append("Childern_No", Childern_No);
    formdata_reserv.append("prese_Id", Prese_Id);
    formdata_reserv.append("Reserv_Price", Reserv_Price);
    formdata_reserv.append("Reserv_prepayment", Reserv_prepayment);
    formdata_reserv.append("Reserv_Account", Reserv_Account);

    formdata_reserv.append("Reserv_Extrabed", Reserv_Extrabed ? 1 : 0);
    formdata_reserv.append("Reserv_ExtraAmount", Reserv_ExtraAmount);
    formdata_reserv.append("Reserv_Breakfast", Reserv_Breakfast ? 1 : 0);
    formdata_reserv.append("Reserv_BreakfastAmount", Reserv_BreakfastAmount);
    formdata_reserv.append("Reserv_Cancel", Reserv_Cancel ? 1 : 0);
    formdata_reserv.append("Reserv_Discount", Reserv_Discount);
    formdata_reserv.append("Reserv_Rate", Reserv_Rate);
    formdata_reserv.append("Reserv_Gel", Reserv_total * Reserv_Rate);
    formdata_reserv.append("Reserv_Other", Reserv_other);
    formdata_reserv.append("Reserv_Total", Reserv_total);
    formdata_reserv.append("Reserv_Base_Price", Base_Price);
    formdata_reserv.append("Reserv_prepaymenReserv", Reserv_prepaymenReserv);
    formdata_reserv.append("U_id", localStorage.getItem('U_id'));
    formuser.append("U_id", localStorage.getItem('U_id'));
    formuser.append("Object_Id", 1);
    formuser.append("Room_Number", localStorage.getItem("Room_Number"));
    uparams.append("From_Date", azdatestr);
    uparams.append("To_Date", tadatestr);
    uparams.append("Room_Number", localStorage.getItem("Room_Number"));

    if (Reserv_ExtraAmount === undefined) {
      setReserv_ExtraAmount(0)
    }
    if (Reserv_Breakfast === undefined) {
      setReserv_Breakfast(0)
    }
    if (Reserv_BreakfastAmount === undefined) {
      setReserv_BreakfastAmount(0)
    }
 //   formdata_reserv.append("Reserv_Extrabed", Reserv_Extrabed);
    let response;
    let parsed;
   
    if (Pass_Id > 0) {
      // update
      let azdate1 = new Date(Reserv_Checkindate);
      let azdate2 = new Date(Checkindate_Old);
      let tadate1 = new Date(Reserv_Checkoutdate);
      let tadate2 = new Date(Checkoutdate_Old);
      let azmon = 0;
      let tamon = 0;
      azmon = azdate1.getMonth();
      azmon = azmon + 1;
      tamon = tadate1.getMonth();
      tamon = tamon + 1;
      let azdatestr1 = azdate1.getFullYear() + '-' + azmon + '-' + azdate1.getDate();
      let tadatestr1 = tadate1.getFullYear() + '-' + tamon + '-' + tadate1.getDate();
      azmon = azdate2.getMonth();
      azmon = azmon + 1;
      tamon = tadate2.getMonth();
      tamon = tamon + 1;

      let azdatestr2 = azdate2.getFullYear() + '-' + azmon + '-' + azdate2.getDate();
      let tadatestr2 = tadate2.getFullYear() + '-' + tamon + '-' + tadate2.getDate();

      if (azdatestr1 !== azdatestr2 || tadatestr1 !== tadatestr2) {
       
        // let rescheck = await GetDataPromise(`${apiMain}/api/v1/reservation/checkexistroomdate?${uparams}`, true);
        // let parsed_check = JSON.parse(rescheck);

        // if (((parsed_check.status && parsed_check.status !== "error") || parsed_check.status === "success")) {
        //   flag=false;
        //   setalertType(0)
        //   settxtMessage('The date entered is duplicate.The information could not be saved.')
        // setError(true)
        // //    alert('The date entered is duplicate.The information could not be saved.')
      

        //   return ;
        // }
      }
      if (Reserv_Id===1)
      {
      let rescheck = await GetDataPromise(`${apiMain}/api/v1/reservation/checkexistroomdate?${uparams}`, true);
      let parsed_check = JSON.parse(rescheck);

      if (((parsed_check.status && parsed_check.status !== "error") || parsed_check.status === "success")) {
      
        flag=false;
        setalertType(0)
        settxtMessage("The date entered is duplicate.The information could not be saved.")
        setError(true);
     return;
      }
    }
      response = await PostDataPromise(apiMain + "/api/v1/passenger/update", formdata);

      // let parsed = JSON.parse(response);
      if (imgURL !== '')
        response = await PostDataPromise(apiMain + "/api/v1/passenger/insertFile", formFiledata);
        console.log(response)
      formuser.append("U_Action", 'Edit');
      formuser.append("Reserv_Id", Reserv_Id);
      // formdata_reserv.append("Pass_Id",parsed.data[0]);
      response = await PostDataPromise(apiMain + "/api/v1/reservation/update", formdata_reserv);
      response = await PostDataPromise(apiMain + "/api/v1/usercontrol/insert", formuser);

    } else {

      let rescheck = await GetDataPromise(`${apiMain}/api/v1/reservation/checkexistroomdate?${uparams}`, true);
      let parsed_check = JSON.parse(rescheck);
      
      if (((parsed_check.status && parsed_check.status !== "error") || parsed_check.status === "success")) {
      
        flag=false;
        setalertType(0)
        settxtMessage("The date entered is duplicate.The information could not be saved.")
        setError(true);
     return;
      //  alert('The date entered is duplicate.The information could not be saved.')
  
      }
      else {
        
        response = await PostDataPromise(apiMain + "/api/v1/passenger/insert", formdata, true);
        parsed = JSON.parse(response);
        if (!((parsed.status && parsed.status !== "error") || parsed.status === "success")) {
          alert('error')
          if (parsed.data && typeof parsed.data.message === "string") {
            enqueueSnackbar((parsed.data) ? parsed.data.message : "", { variant: "error" });
          }
          setDialogError((parsed.data) ? parsed.data.message : {});
          return;
        }
        setPass_Id(parsed.data[0]);
        formuser.append("U_Action", 'Add');
        formdata_reserv.append("Pass_Id", parsed.data[0]);
        response = await PostDataPromise(apiMain + "/api/v1/reservation/insert", formdata_reserv, true);
        // let parsed1 = JSON.parse(response);
        let res = await GetDataPromise(`${apiMain}/api/v1/reservation/selectmax`, false);
        let parsed2 = JSON.parse(res);
        formuser.append("Reserv_Id", parsed2.data);
       
        response = await PostDataPromise(apiMain + "/api/v1/usercontrol/insert", formuser);
     
      }
      setLoading(false)
    }
    response = await PostDataPromise(apiMain + "/api/v1/compan/delete", formdata);
    formdata.append("Pass_Id", Pass_Id);
    for (let i = 0; i < Companion.length; i++) {
      if (Companion[i].fname !== '') {
        formdata.append("Com_FName", Companion[i].fname);
        formdata.append("Com_LName", Companion[i].lname);
        formdata.append("Com_Pass_No", Companion[i].pass);
        response = await PostDataPromise(apiMain + "/api/v1/compan/insert", formdata)
      }
    }
   // let p = props.getDataCard();
    setError(false);
    getMyData(mytoday);
    //  getMyData();
    getDay(mytoday);
    getShowData();
if (flag)
  //  alert('Information saved.')
    setalertType(1)
    settxtMessage("Information saved.")
    setError(true);
  }
  const sendChangeRoom = async (e) => {
    //  e.preventDefault()
   //  setLoading(true)

      let uparams = new URLSearchParams();
      let formuser = new FormData();
      let formdata_reserv = new FormData();
      let azdate = new Date(ChangeRoom_Checkindate);
      let tadate = new Date(Reserv_Checkoutdate);
      let azdatestr = new Date();
      let tadatestr = new Date();
      azdatestr = Date.parse(Reserv_Checkindate)
      //  let keys = Object.keys(data);
      // let errors = {};
      let azmon = 0;
      let tamon = 0;
      azmon = azdate.getMonth();
      azmon = azmon + 1;
      tamon = tadate.getMonth();
      tamon = tamon + 1;
      azdatestr = azdate.getFullYear() + '-' + azmon + '-' + azdate.getDate();
  
      tadatestr = tadate.getFullYear() + '-' + tamon + '-' + tadate.getDate();
  

      formdata_reserv.append("Reserv_Id", 0);
      formdata_reserv.append("Pass_Id", Pass_Id);
      formdata_reserv.append("Room_Number", changeRoom_No);
      formdata_reserv.append("Reserv_Checkindate", azdatestr);
      formdata_reserv.append("Reserv_Checkoutdate", tadatestr);
      formdata_reserv.append("Adults_No", Adults_No);
      formdata_reserv.append("Night_No", Nights_No);
      formdata_reserv.append("Childern_No", Childern_No);
      formdata_reserv.append("prese_Id", Prese_Id);
      formdata_reserv.append("Reserv_Price", Reserv_Price);
      formdata_reserv.append("Reserv_prepayment", Reserv_prepayment);
      formdata_reserv.append("Reserv_Account", Reserv_Account);
        if (Reserv_Cancel)
       { formdata_reserv.append("Reserv_Type", 4);}
        else
     { formdata_reserv.append("Reserv_Type", props.Reserv_Type);}
  
      formdata_reserv.append("Reserv_Extrabed", Reserv_Extrabed ? 1 : 0);
      formdata_reserv.append("Reserv_ExtraAmount", Reserv_ExtraAmount);
      formdata_reserv.append("Reserv_Breakfast", Reserv_Breakfast ? 1 : 0);
      formdata_reserv.append("Reserv_BreakfastAmount", Reserv_BreakfastAmount);
      formdata_reserv.append("Reserv_Cancel", Reserv_Cancel ? 1 : 0);
      formdata_reserv.append("Reserv_Discount", Reserv_Discount);
      formdata_reserv.append("Reserv_Rate", Reserv_Rate);
      formdata_reserv.append("Reserv_Gel", Reserv_Gel);
      formdata_reserv.append("Reserv_Other", Reserv_other);
      formdata_reserv.append("Reserv_Total", Reserv_total);
      formdata_reserv.append("Reserv_Base_Price", Base_Price);
      formdata_reserv.append("Reserv_prepaymenReserv", Reserv_prepaymenReserv);
      
      formdata_reserv.append("U_id", localStorage.getItem('U_id'));
      formuser.append("U_id", localStorage.getItem('U_id'));
      formuser.append("Object_Id", 1);
      formuser.append("Room_Number", localStorage.getItem("Room_Number"));
      uparams.append("From_Date", azdatestr);
      uparams.append("To_Date", tadatestr);
      uparams.append("Room_Number", localStorage.getItem("Room_Number"));
  
      if (Reserv_ExtraAmount === undefined) {
        setReserv_ExtraAmount(0)
      }
      if (Reserv_Breakfast === undefined) {
        setReserv_Breakfast(0)
      }
      if (Reserv_BreakfastAmount === undefined) {
        setReserv_BreakfastAmount(0)
      }
   //   formdata_reserv.append("Reserv_Extrabed", Reserv_Extrabed);
      let response;
      let parsed;
              setPass_Id(parsed.data[0]);
          formuser.append("U_Action", 'Add');
          formdata_reserv.append("Pass_Id", parsed.data[0]);
          response = await PostDataPromise(apiMain + "/api/v1/reservation/insert", formdata_reserv, true);
          // let parsed1 = JSON.parse(response);
          let res = await GetDataPromise(`${apiMain}/api/v1/reservation/selectmax`, false);
          let parsed2 = JSON.parse(res);
          formuser.append("Reserv_Id", parsed2.data);
         
          response = await PostDataPromise(apiMain + "/api/v1/usercontrol/insert", formuser);
  
      
        setLoading(false)
      }


  //  const [count, setCount] = useState(0); // useState returns a pair. 'count' is the current state. 'setCount' is a function we can use to update the state.
  function allitemupdate(param) {
    console.log(param)
    setPass_LName(param.Pass_LName);
    setPass_FName(param.Pass_FName);

    setPass_No(param.Pass_No);
    setPrese_Id(param.Prese_Id);
    setPass_Email(param.Pass_Email);
    setPass_PhonNo(param.Pass_PhonNo);
    setImgURL(param.Reserv_UrlFile);

    setChildern_No(param.Childern_No);

    if (param.Reserv_Extrabed === null) { setReserv_Extrabed(0); }
    else {
      setReserv_Extrabed(param.Reserv_Extrabed);
    }
    if (param.Reserv_ExtraAmount === null) { setReserv_ExtraAmount(0); }
    else {
      setReserv_ExtraAmount(param.Reserv_ExtraAmount);
    }
    if (param.Reserv_Type === 2) {
      setinouttype(true)
    }
    else {
      setinouttype(false)
    }
    setReserv_Checkindate(param.Reserv_Checkindate);
    setReserv_Checkoutdate(param.Reserv_Checkoutdate);
    setCheckindate_Old(param.Reserv_Checkindate);
    setCheckoutdate_Old(param.Reserv_Checkoutdate);
    setReserv_Breakfast(param.Reserv_Breakfast);
    if (Reserv_BreakfastAmount === null) {
      setReserv_BreakfastAmount(0);
    }
    else {
      setReserv_BreakfastAmount(param.Reserv_BreakfastAmount);
    }

    setReserv_Price(param.Reserv_Price);
    setReserv_prepayment(param.Reserv_prepayment);
    setReserv_Gelprepayment(Math.round(param.Reserv_prepayment * param.Reserv_Rate,2).toFixed(2));
    setReserv_Account(param.Reserv_Account);
    setReserv_Discount(param.Reserv_Discount);
    setReserv_GelDiscount(Math.round(param.Reserv_Discount * param.Reserv_Rate,2).toFixed(2));
    setReserv_Rate(param.Reserv_Rate);
    setReserv_Gel(param.Reserv_Gel);
    setReserv_Id(param.Reserv_Id);
    setReserv_other(param.Reserv_Other);
    setReserv_Gelother(Math.round(param.Reserv_Other * param.Reserv_Rate,2).toFixed(2));
    setPass_Id(param.Pass_Id);
    setPrese_Id(param.prese_Id);
    SetEnaDisa('disabled')
    SetEnaDisacheckin('disabled')
    getcompanion(param.Pass_Id)
    setAdults_No(param.Adults_No);
    setNights_No(param.Night_No);
    setReserv_Cancel(param.Reserv_Cancel);
    setBase_Price(param.Reserv_Base_Price);
    setReserv_prepaymenReserv(param.Reserv_prepaymenReserv);
    setReserv_GelprepaymenReserv(Math.round(param.Reserv_prepaymenReserv * param.Reserv_Rate,2).toFixed(2));
    getDay(new Date(param.Reserv_Checkindate));

    getMyData(new Date(param.Reserv_Checkindate))

    //    getMyData()
  }

 
  function incrementadults() {
    //setCount(prevCount => prevCount+=1);
    setAdults_No(function (prevCount) {
      return (prevCount += 1);
    });
  }

  function decrementadults() {
    setAdults_No(function (prevCount) {
      if (prevCount > 0) {
        return (prevCount -= 1);
      } else {
        return (prevCount = 0);
      }
    });
  }
  function incrementchildern() {
    //setCount(prevCount => prevCount+=1);
    setChildern_No(function (prevCount) {
      return (prevCount += 1);
    });
  }
  function decrementchildren() {
    setChildern_No(function (prevCount) {
      if (prevCount > 0) {
        return (prevCount -= 1);
      } else {
        return (prevCount = 0);
      }
    });
  }
  function incrementNights() {
    //setCount(prevCount => prevCount+=1);


    let temp = 0
    setNights_No(function (prevCount) {
      temp = prevCount + 1;
      return (prevCount += 1);

    });



    roomRate(temp, Prese_Id);

  }

  function decrementNights() {
    let temp = 0
    setNights_No(function (prevCount) {

      if (prevCount > 0) {
        temp = prevCount - 1
        return (prevCount -= 1);
      } else {
        temp = 0
        return (prevCount = 0);
      }
    });
    roomRate(temp);
  }
const ChangeRoom=()=>{
 setChangeRoomFlag(true)
}

  const handleReset = () => {
    // Reset all state variables here
    setPass_FName("");
    setPass_LName("");
    setPass_No("");
    setPass_Email("");
    setPass_PhonNo("");
    setReserv_Checkindate(new Date());
    setReserv_Checkoutdate(new Date());
    // setRType_Id(0);
    setPrese_Id(0);
    setAdults_No(0);
    setNights_No(0);
    setChildern_No(0);
    setReserv_Account(0);
    setReserv_Discount(0);
    setReserv_Rate(0);
    setReserv_Gel(0);
    setReserv_Price(0);
    setReserv_prepaymenReserv(0);
    SetEnaDisa("")
   // localStorage.setItem('Reserv_Id', 0)
    setReserv_Id(0)
    setPass_Id(0)
      SetEnaDisacheckin("")
   
  };
  //let wid = window.innerWidth;
  const headerStyle = {
    backgroundColor: "#1976d2",
    color: "white",
    fontWeight: "bold",
    fontSize: "11px",
    padding: "2px 6px",
    textAlign: "center",
  
    height: "28px",      // ارتفاع کمتر / بیشتر
    lineHeight: "14px",
  
    width: "120px",      // 👈 عرض بزرگ‌تر
    whiteSpace: "nowrap" // جلوگیری از شکستن متن
  };
  

  const cellStyle = {
    height: 20,

    "& .MuiTableCell-root": {
      padding: "2px 4px !important",
      height: "20px",
      lineHeight: "20px",
    
  
  }
  };
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  function  HandelChangeRoom ()  {
    // alert(props.Room_No)

     if(ChangeRoom_No === '0')
     {
      alert("Please select a room")
     }
     else
     {
      sendChangeRoom()
     }
    // alert(Reserv_Id)
    // alert(ChangeRoom_Checkindate)
  };
  const fullUrl = `https://lhapi.luxintrip.com/images/${imgURL}`;
  const pdfPreviewUrl = `https://docs.google.com/gview?embedded=true&url=${fullUrl}`;
  return (
    //style={{ backgroundColor: 'black', height: '600px' }}
    <div  style={{  display: "flex",   alignItems: "flex-start",justifyContent: "flex-start"}}
  >
     <Box style={{ width:'600px', marginLeft:'10px' }}>
      <Box className="CheckIn" 
      style={{
      textAlign: 'left'
       ,width:'670px'
       ,marginLeft:'10px' }}
        component="form"
        sx={{ '& > :not(style)': { m: 1 } }}
        noValidate
        autoComplete="off"
      >
        <div style={{ float: 'left', paddingTop: '40px',marginLeft:'0px' }}>

          <svg width="60" height="60" viewBox="0 0 161 161" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="80.0977" cy="80.0977" r="69.7625" fill="#EDD682">
              <animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.1"
              /> </circle>
            <path d="M103.02 52.8957H99.4139V50.7576H99.9351C100.991 50.7576 101.781 49.7845 101.559 48.7496L101.031 46.2817L101.031 46.2808C100.868 45.5203 100.185 44.968 99.407 44.968H97.7012C96.9226 44.968 96.2397 45.5203 96.077 46.2817L95.5494 48.7487C95.3274 49.7835 96.1157 50.7575 97.1733 50.7575H97.6946V52.8955H93.9505V43.2968C93.9505 41.0127 92.0919 39.1542 89.8079 39.1542H64.9109C62.6268 39.1542 60.7683 41.0127 60.7683 43.2968V52.8957H56.5945V50.7576H57.1158C58.1721 50.7576 58.9618 49.7848 58.7405 48.7496L58.212 46.2817C58.0491 45.5203 57.3662 44.968 56.5877 44.968H54.8824C54.1047 44.968 53.4214 45.5203 53.2582 46.2808L53.2577 46.2817L52.7297 48.7496C52.508 49.7866 53.3 50.7576 54.354 50.7576H54.8752V52.8957H51.2687C50.2685 52.8957 49.4547 53.7091 49.4547 54.7097V59.93C49.4547 60.9307 50.2685 61.744 51.2687 61.744H51.8688V62.8143C51.8688 63.2894 52.2538 63.6738 52.7284 63.6738C53.203 63.6738 53.5879 63.2894 53.5879 62.8143V61.744H58.0015L54.9081 67.3875C54.8266 67.5362 54.8187 67.7145 54.8023 67.8005V74.0555C54.0409 74.3224 53.4902 75.0409 53.4902 75.8926V79.2226C53.4902 80.3004 54.3666 81.1768 55.444 81.1768H98.4778C99.5552 81.1768 100.432 80.3004 100.432 79.2226V75.8926C100.432 75.041 99.8813 74.3227 99.12 74.0555V67.8005C99.1034 67.714 99.0965 67.5375 99.0142 67.3875L95.9204 61.744H100.701V62.8143C100.701 63.2894 101.086 63.6738 101.56 63.6738C102.035 63.6738 102.42 63.2894 102.42 62.8143V61.744H103.02C104.021 61.744 104.835 60.9306 104.835 59.93V54.7097C104.835 53.709 104.021 52.8957 103.02 52.8957ZM97.7013 46.6872H99.36L99.8628 49.0384H97.2438L97.7013 46.6872ZM54.9295 46.6855L56.5307 46.641L57.0439 49.0384H54.4262L54.9295 46.6855ZM58.7912 63.8804H95.1305L96.8085 66.941H57.1132L58.7912 63.8804ZM56.5215 68.6602H97.4008V73.9385H56.5215V68.6602ZM59.7331 62.1613L64.0486 54.2882C64.4739 53.5722 65.2494 53.1289 66.0794 53.1106C66.1922 54.1416 67.0582 54.9497 68.1185 54.9497H73.0384C74.1011 54.9497 74.9685 54.138 75.0782 53.1038H78.8434C78.9531 54.138 79.8205 54.9497 80.8832 54.9497H85.8031C86.8634 54.9497 87.7294 54.1416 87.8422 53.1106C88.6676 53.1289 89.4389 53.568 89.8659 54.2757L94.1887 62.1613H59.7331ZM67.7761 52.8881V51.5996C67.7761 51.4107 67.9298 51.2571 68.1186 51.2571H73.0385C73.2273 51.2571 73.381 51.4107 73.381 51.5996V52.8881C73.381 53.077 73.2273 53.2306 73.0385 53.2306H68.1186C67.9297 53.2306 67.7761 53.077 67.7761 52.8881ZM80.5409 52.8881V51.5996C80.5409 51.4107 80.6946 51.2571 80.8834 51.2571H85.8033C85.9921 51.2571 86.1458 51.4107 86.1458 51.5996V52.8881C86.1458 53.077 85.9921 53.2306 85.8033 53.2306H80.8834C80.6945 53.2306 80.5409 53.077 80.5409 52.8881ZM64.9109 40.8734H89.808C91.1444 40.8734 92.2314 41.9604 92.2314 43.2968V55.0144L91.3657 53.4355C91.3607 53.4262 91.3556 53.4178 91.3506 53.4086C90.6169 52.1757 89.2765 51.407 87.8436 51.3883C87.736 50.352 86.8676 49.538 85.8033 49.538H80.8834C79.8205 49.538 78.9528 50.3501 78.8435 51.3848H75.0784C74.9692 50.3501 74.1015 49.538 73.0385 49.538H68.1186C67.0545 49.538 66.186 50.352 66.0784 51.3883C64.6453 51.407 63.3048 52.176 62.5561 53.4355L62.4874 53.5607V43.2968C62.4875 41.9604 63.5745 40.8734 64.9109 40.8734ZM51.2687 60.025C51.2161 60.025 51.1738 59.9821 51.1738 59.9302V54.7098C51.1738 54.6577 51.2163 54.615 51.2687 54.615H60.2963V57.558L58.944 60.0251H51.2687V60.025ZM98.7129 79.2226C98.7129 79.3519 98.6075 79.4577 98.4778 79.4577H55.444C55.3148 79.4577 55.2094 79.3519 55.2094 79.2226V75.8926C55.2094 75.7634 55.3148 75.6576 55.444 75.6576H98.4778C98.6075 75.6576 98.7129 75.7634 98.7129 75.8926V79.2226ZM103.116 59.93C103.116 59.9821 103.073 60.0249 103.02 60.0249H94.9781L93.9927 58.2274V54.6147H103.02C103.073 54.6147 103.116 54.6576 103.116 54.7095V59.93Z" fill="#2C2C2C" />
            <circle cx="80.0976" cy="80.0976" r="78.5976" stroke="#EDD682" stroke-width="3" />
            <rect x="39.126" y="94.493" width="78.9903" height="25.838" rx="12.919" fill="#2C2C2C" />
            <text x="60.130" y="115.493" fontSize={24} fontWeight={'bold'} fill="white">{props.Room_No}</text>
          </svg>

        </div>
        {/* <img onClick={() => handleClosereservation()} src={ico2} alt={"/"} style={{ float: 'right', width: '30px', height: '30px', cursor: 'pointer' }} /> */}

        <Stack spacing={1} sx={{ alignItems: 'center' }}></Stack>

        <Stack direction="row" spacing={0.2} >
          {/* <Chip  label="Top Room Reservation" color="" style={{width:"150px", fontWeight:"bold",backgroundColor:"#EDD682"}} /> */}
          <Chip className="chipday" label={Day[0]} sx={{ backgroundColor: colr[0] ,fontSize:10}} />
          <Chip className="chipday" label={Day[1]} sx={{ backgroundColor: colr[1] ,fontSize:10}} />
          <Chip className="chipday" label={Day[2]} sx={{ backgroundColor: colr[2] ,fontSize:10}} />
          <Chip className="chipday" label={Day[3]} sx={{ backgroundColor: colr[3] ,fontSize:10}} />
          <Chip className="chipday" label={Day[4]} sx={{ backgroundColor: colr[4] ,fontSize:10}} />
          <Chip className="chipday" label={Day[5]} sx={{ backgroundColor: colr[5] ,fontSize:10}} />
      
        </Stack>

        <Stack direction="row" spacing={0.2}   style={{ marginTop: "-5px" }}  
        >
          {/* <Chip  label={"Room Number : " + localStorage.getItem("Room_Number")} color="" style={{width:"150px", fontWeight:"bold",backgroundColor:"#EDD682"}} /> */}
      
          <Chip className="chipday" label={Day[6]} sx={{ backgroundColor: colr[6] ,fontSize:10}} />
          <Chip className="chipday" label={Day[7]} sx={{ backgroundColor: colr[7] ,fontSize:10}} />
          <Chip className="chipday" label={Day[8]} sx={{ backgroundColor: colr[8] ,fontSize:10}} />
          <Chip className="chipday" label={Day[9]} sx={{ backgroundColor: colr[9] ,fontSize:10}} />
          <Chip className="chipday" label={Day[10]} sx={{ backgroundColor: colr[10] ,fontSize:10}} />
          <Chip className="chipday" label={Day[11]} sx={{ backgroundColor: colr[11] ,fontSize:10}} />
                 </Stack>
        <Stack direction="row" spacing={0.2} style={{ marginTop: "-5px" }}> 
          {/* <Chip  label={"Room Number : " + localStorage.getItem("Room_Number")} color="" style={{width:"150px", fontWeight:"bold",backgroundColor:"#EDD682"}} /> */}
   
          <Chip className="chipday" label={Day[12]} sx={{ backgroundColor: colr[12] ,fontSize:10}} />
          <Chip className="chipday" label={Day[13]} sx={{ backgroundColor: colr[13] ,fontSize:10}} />
          <Chip className="chipday" label={Day[14]} sx={{ backgroundColor: colr[14] ,fontSize:10}} />
          <Chip className="chipday" label={Day[15]} sx={{ backgroundColor: colr[15] ,fontSize:10}} />
           <Chip className="chipday" label={Day[16]} sx={{ backgroundColor: colr[16] ,fontSize:10}} />
          <Chip className="chipday" label={Day[17]} sx={{ backgroundColor: colr[17] ,fontSize:10}} />
                  </Stack>
        <Stack direction="row" spacing={0.2} style={{marginLeft:'70px', marginTop: "-5px" }}> 
          {/* <Chip  label={"Room Number : " + localStorage.getItem("Room_Number")} color="" style={{width:"150px", fontWeight:"bold",backgroundColor:"#EDD682"}} /> */}
   
            <Chip className="chipday" label={Day[18]} sx={{ backgroundColor: colr[18] ,fontSize:10}} />
          <Chip className="chipday" label={Day[19]} sx={{ backgroundColor: colr[19] ,fontSize:10}} />
          <Chip className="chipday" label={Day[20]} sx={{ backgroundColor: colr[20] ,fontSize:10}} />
          <Chip className="chipday" label={Day[21]} sx={{ backgroundColor: colr[21] ,fontSize:10}} />
          <Chip className="chipday" label={Day[22]} sx={{ backgroundColor: colr[22] ,fontSize:10}} />
          <Chip className="chipday" label={Day[23]} sx={{ backgroundColor: colr[23] ,fontSize:10}} />
                  </Stack>
        <Stack direction="row" spacing={0.2} style={{marginLeft:'70px',  marginTop: "-5px" }}> 
          {/* <Chip  label={"Room Number : " + localStorage.getItem("Room_Number")} color="" style={{width:"150px", fontWeight:"bold",backgroundColor:"#EDD682"}} /> */}
   
            <Chip className="chipday" label={Day[24]} sx={{ backgroundColor: colr[24] ,fontSize:10}} />
          <Chip className="chipday" label={Day[25]} sx={{ backgroundColor: colr[25] ,fontSize:10}} />
          <Chip className="chipday" label={Day[26]} sx={{ backgroundColor: colr[26] ,fontSize:10}} /> 
          <Chip className="chipday" label={Day[27]} sx={{ backgroundColor: colr[27] ,fontSize:10}} />
          <Chip className="chipday" label={Day[28]} sx={{ backgroundColor: colr[28] ,fontSize:10}} />
          <Chip className="chipday" label={Day[29]} sx={{ backgroundColor: colr[29],fontSize:10 }} />
        </Stack>
        {/* <Stack direction="row" spacing={0.2} style={{ marginTop: "-5px" }}>

  
        </Stack> */}
      </Box>
      <div className="CheckIn" style={{height:'40px', textAlign: 'left',width:'670px', marginTop: '-5px',marginLeft:'10px', lineHeight: '.4' }}>
        <fieldset>
          <form action="#" method="get">
            <div >
              <label for="Chekindate" style={{ fontSize:'10px'}} >  Chek in date* </label>
              <label style={{ paddingLeft: "20px" ,fontSize:'10px'}} for="checkoutdate">Chek out date*</label>
              <label style={{ paddingLeft: "30px",fontSize:'10px' }} for="Nights">Nights*</label>
              {/* <label style={{ paddingLeft: "120px" ,fontSize:'12px'}} for="Rooms">Rooms Type</label> */}
              <label style={{ paddingLeft: "90px" ,fontSize:'10px'}} for="PassportNo">Reserve Type *</label>
              <label style={{ paddingLeft: "30px" ,fontSize:'10px'}} for="PassportNo">Breakfast</label>
              <label style={{ paddingLeft: "20px" ,fontSize:'10px'}} for="PassportNo">Extra</label>
    
               {/* <label style={{ paddingLeft: "30px",fontSize:'10px' }} for="Amount">{Reserv_Breakfast ? 'Amount' : ''}</label> */}
         
         
            </div>
            <div style={{marginTop:'5px'}}>


              <DatePicker
                style={{ height: "25px" ,width:'75px'}}
                // inputClass={"rmdp-input "+ classes + " " + className}
                className={((window.innerWidth < 850) ? "rmdp-mobile " : "")}
                name="Checkindate"
                required={true}
                disabled={EnaDisa}
                calendarPosition="bottom"
                format='YYYY-MM-DD'
                //   minDate={new Date()}
                calendar={gregorian}
                //    locale={"en"}
                value={Reserv_Checkindate}
                onChange={(e) => setReserv_Checkindate(e)}
                range={false}
              //  rangeHover={range}
              />


              <DatePicker
                style={{ height: "25px", marginLeft: "20px" ,width:'75px'}}
                // inputClass={"rmdp-input "+ classes + " " + className}
                className={((window.innerWidth < 850) ? "rmdp-mobile " : "")}
                name="Checkoutdate"
                required={true}
                disabled={EnaDisa}
                calendarPosition="bottom"
                format='YYYY-MM-DD'
                minDate={Reserv_Checkindate}
                calendar={gregorian}
                locale={"en"}
                value={Reserv_Checkoutdate}
                onChange={onchangeCheckoutdate}
              // onChange={(Rrv_Checkoutdate) =>
              //   { setReserv_Checkoutdate(Reserv_Checkoutdate)
              //   setNights_No(Reserv_Checkoutdate.getDate()-Reserv_Checkindate.getDate())
              //   }}

              // range={range}
              // rangeHover={range}
              />
              <ButtonGroup>
                <Button className="bin" disabled='disabled' style={{ backgroundColor: 'gray', color: "white", marginLeft: '30px' }} onClick={incrementNights}>+</Button>
                <input className="iin" disabled='disabled' value={Nights_No}></input>
                <Button className="bin" disabled='disabled' style={{ backgroundColor: 'gray', color: "white" }} onClick={decrementNights}>-</Button>
              </ButtonGroup>
              
              <Select style={{ width: '90px', height: '25px',fontSize:'12px', marginLeft: '15px', backgroundColor: "rgb(225, 225, 198)" }}
                labelId="demo-multiple-name-label"
                id="demo-multiple-name"
                disabled={EnaDisa}
                value={Prese_Id}
                onChange={changePeres_Id}
                input={<OutlinedInput label="Name" />}
                MenuProps={MenuProps}
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                {PresentTypeData.map((dat) => (
                  <MenuItem key={dat.value} value={dat.value}>{dat.label}</MenuItem>
                ))}

              </Select>
              <input style={{ marginLeft: "30px", width: '30px' }}
                type="checkbox"
                name="Reserv_Breakfast"
                id="Reserv_Breakfast"
                disabled={props.Reserv_Type !== 0 ? EnaDisa : true}
                value={Reserv_Breakfast}
                checked={Reserv_Breakfast}
                onChange={(e) => setReserv_Breakfast(e.target.checked)}
                defaultValue={0}
                //placeholder=""
                required
              />
                         <input style={{ marginLeft: "30px", width: '30px' }}
                type="checkbox"
                name="Reserv_Extrabed"
                id="Reserv_Extrabed"
                disabled={props.Reserv_Type !== 0 ? EnaDisa : true}
                value={Reserv_Extrabed}
                checked={Reserv_Extrabed}
                onChange={(e) => setReserv_Extrabed(e.target.checked)}
                defaultValue={0}
                //placeholder=""
                required
              />
            </div>
          </form>
        </fieldset>
      </div>
      <div className="CheckIn" style={{height:'30px', textAlign: 'left',width:'670px', marginTop: '-5px',marginLeft:'10px', lineHeight: '.4' }}>
        <fieldset>
          <form action="#" method="get">
            <div >
              <label for="Chekindate" style={{ fontSize:'10px'}} >  Pernight Room </label>
              <label style={{ paddingLeft: "20px",fontSize:'10px' }} for="Breakfast">Breakfast</label>
              <label style={{ paddingLeft: "50px",fontSize:'10px' }} for="Breakfast">Extra</label>
              <label style={{ paddingLeft: "70px",fontSize:'10px' }} for="Breakfast">Rate</label>
              <label style={{ paddingLeft: "70px",fontSize:'10px' }} for="Breakfast">Cancel</label>
             </div>
            <div style={{marginTop:'5px'}}>

              <ButtonGroup>
                  <input style={{  width: '70px',height:'20px' }} className="iin" disabled='disabled' value={Base_Price}></input>
                 </ButtonGroup>
               <input style={{ marginLeft: "30px", width: '70px',height:'20px' }}
             //   type={Reserv_Breakfast ? "text" : "hidden"}
                name="Reserv_BreakfastAmount"
                id="Reserv_BreakfastAmount"
                disabled={!Reserv_Breakfast}
                value={Reserv_BreakfastAmount}
                onChange={changeBreakfastAmount}
            //    defaultValue={1}
                //placeholder=""
                required
              />
            <input style={{ marginLeft: "30px", width: '70px',height:'20px'}}
             //s type={Reserv_Extrabed ? "text" : "hidden"}
              name="Reserv_ExtraAmount"
              id="Reserv_ExtraAmount"
              disabled={!Reserv_Extrabed}
              value={Reserv_ExtraAmount}
           //   defaultValue={0}
              onChange={changeExtraAmount}

              //placeholder=""
              required
           />
       <input style={{ marginLeft: "30px", width: '70px',height:'20px' }}
                    name="Reserv_ExtraAmount"
              id="Reserv_ExtraAmount"
              disabled={EnaDisa}
              value={Reserv_Rate}
           //   defaultValue={0}
              onChange={changeReserv_Rate}

              //placeholder=""
              required

              
            />
            <input style={{ marginLeft: "30px", width: '30px' }}
                type="checkbox"
                name="Reserv_Cancel"
                id="Reserv_Cancel"
                disabled={props.Reserv_Type === 1 ? EnaDisa : true}
                value={Reserv_Cancel}
                checked={Reserv_Cancel}
                onChange={(e) => setReserv_Cancel(e.target.checked)}
                defaultValue={0}
                //placeholder=""
                required
              />
            </div>
          </form>
        </fieldset>
      </div>
      <div className="CheckIn" style={{height: '100px',width:'670px', textAlign: 'left', marginTop: '-5px', lineHeight: '.1',marginLeft:'10px' }}>
        <fieldset>
          <form action="#" method="get">
            <div style={{marginTop:'5px'}}>
              <label style={{fontSize:'10px'}} for=""> First Name* </label>
              <label style={{ paddingLeft: "60px",fontSize:'10px' }} for="lastname">Last Name*</label>
              <label style={{ paddingLeft: "60px" ,fontSize:'10px'}} for="PassportNo">Passport No*</label>

            </div>
            <div style={{ textAlign: 'left', marginTop: '5px', lineHeight: '.1' }}>
              <input style={{ height: "25px",width:'110px' }}
                type="text"
                id="firstname"
                disabled={EnaDisa}
                value={Pass_FName}
                onChange={(e) =>
                  setPass_FName(e.target.value)
                }
                // //placeholder="Enter First Name"
                required
              />


              <input style={{ marginLeft: "10px" ,height: "25px",width:'110px'}}
                type="text"
                name="lastname"
                id="lastname"
                disabled={EnaDisa}
                value={Pass_LName}
                onChange={(e) =>
                  setPass_LName(e.target.value)
                }
                required
              />
              <input style={{ marginLeft: "10px" ,height: "25px",width:'110px'}}
                type="text"
                name="Passportno"
                id="Passportno"
                disabled={EnaDisa}
                value={Pass_No}
                onChange={(e) =>
                  setPass_No(e.target.value)
                }
                // //placeholder="Enter Passport No"
                required
              />
              {/* <FormControl sx={{ m: 1, minWidth: 150 }} > */}
              <input
              type="file"
               name="file" 
               onChange={onChangeHandler} 
               style={{ marginLeft: '20px' }} />
             {/* نمایش فایل (تصویر یا PDF) */}
             {imgURL && typeof imgURL === "string" && (
  isPDF ? (
    <span
      onClick={() => setOpenPDF(true)}
      style={{
        display: "inline-flex",   // <-- مهم
        alignItems: "center",
        justifyContent: "center",
        width: "60px",
        height: "40px",
        borderRadius: "8px",
        backgroundColor: "#f5f5f5",
        cursor: "pointer",
        boxShadow: "0 0 4px rgba(0,0,0,0.3)",
        transition: "transform 0.2s",
        marginLeft: "0px",
        marginRight: "8px", // فاصله بین آیتم‌ها
      }}
      onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
      onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
    >
      {/* آیکون PDF */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="red"
        width="24px"
        height="24px"
      >
        <path d="M6 2c-1.1 0-2 .9-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6H6zm7 1.5L18.5 9H13V3.5zM8 13h2v5H8v-5zm3 0h2v2h1v3h-3v-5zm5 0h2v1h-1v1h1v3h-2v-5z" />
      </svg>
    </span>
  ) : (
    <img
      src={`https://lhapi.luxintrip.com/images/${imgURL}`}
      alt="preview"
      onClick={handleOpen}
      style={{
        marginLeft: "20px",
        width: "60px",
        height: "40px",
        borderRadius: "8px",
        objectFit: "cover",
        cursor: "pointer",
        boxShadow: "0 0 4px rgba(0,0,0,0.3)",
        transition: "transform 0.2s",
      }}
      onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
      onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
    />
  )
)}

      {/* Popup برای نمایش PDF */}
      {openPDF && (
        <div
          onClick={() => setOpenPDF(false)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "50vw",
            height: "50vh",
            backgroundColor: "rgba(0,0,0,0.7)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              backgroundColor: "#fff",
              borderRadius: "10px",
              overflow: "hidden",
              width: "80%",
              height: "80%",
              boxShadow: "0 0 10px rgba(0,0,0,0.5)",
              position: "relative",
            }}
          >
            <button
              onClick={() => setOpenPDF(false)}
              style={{
                position: "absolute",
                top: "10px",
                right: "15px",
                background: "transparent",
                border: "none",
                fontSize: "24px",
                cursor: "pointer",
              }}
            >
              ✕
            </button>
            <iframe
              src={`https://lhapi.luxintrip.com/images/${imgURL}`}
              width="100%"
              height="100%"
              style={{ border: "none" }}
            ></iframe>
          </div>
        </div>
      )}


        {console.log('=====',isPDF)}
        {isPDF ? (
          <Box
          sx={{
            width: 65,
            height: 30,
            border: "1px solid #ccc",
            borderRadius: 1,
            overflow: "hidden",
            display:'inline-flex',
            backgroundColor: "#f5f5f5",
          }}
        >
          <iframe
            src={pdfPreviewUrl}
            title="PDF preview"
            width="100%"
            height="100%"
            style={{
              border: "none",
              overflow: "hidden",
              pointerEvents: "none",
              transform: "scale(1.7)",
              transformOrigin: "top",
            }}
          />
                </Box>
        ) : (
          ''

        )}


              {/* </FormControl> */}
            </div>
            <div style={{ textAlign: 'left', marginTop: '-10px', lineHeight: '.5' }}>
              <label  style={{fontSize:'10px'}} for="tel">Email*</label  >
              <label style={{ paddingLeft: "90px",fontSize:'10px'}} for="Telephone"> Telephone/Mobile </label>
              <label style={{ paddingLeft: "60px" ,fontSize:'10px'}} for="Adults">Adults*</label>
              <label style={{ paddingLeft: "60px",fontSize:'10px' }} for="Childern">Childern</label>
           </div>
                <div style={{marginTop:'10px'}}>
            <input style={{ height: "25px",width:'110px'}}
              type="email"
              name="email"
              id="email"
              disabled={EnaDisa}
              value={Pass_Email}
              onChange={(e) =>
                setPass_Email(e.target.value)
              }
              //placeholder="Enter email"old
              required
            />

            <input style={{ marginLeft: "10px",height: "25px",width:'110px' }}
              type="tel"
              name="PhonNo"
              id="PhonNo"
              disabled={EnaDisa}
              value={Pass_PhonNo}
              onChange={(e) =>
                setPass_PhonNo(e.target.value)
              }
              //placeholder="Enter Mobile number"
              required
            />

            <ButtonGroup>
              <Button className="bin" style={{ backgroundColor: 'gray', color: "white", marginLeft: '40px' }} onClick={incrementadults}>+</Button>
              <input className="iin" value={Adults_No}></input>
              <Button className="bin" style={{ backgroundColor: 'gray', color: "white" }} onClick={decrementadults}>-</Button>
            </ButtonGroup>
            <ButtonGroup>
              <Button className="bin" style={{ backgroundColor: 'gray', color: "white", marginLeft: '40px' }} onClick={incrementchildern}>+</Button>
              <input className="iin" value={Childern_No}></input>
              <Button className="bin" style={{ backgroundColor: 'gray', color: "white" }} onClick={decrementchildren}>-</Button>
            </ButtonGroup>
      

         
            </div>
          </form>
        </fieldset>
      </div>
     
      <div className="CheckIn" hidden={Adults_No+Childern_No > 1 ? "" : "hidden"} style={{ textAlign: 'left',width:'670px',marginLeft:'10px', marginTop: '-5px', lineHeight: '.5' }}>
        <ul>
          {(() => {

            listItems.length = 0;
            for (let i = 0; i < Adults_No +Childern_No - 1; i++) {
              listItems.push(
                <fieldset>
                  <form action="#" method="get">
                    <div style={{ marginTop: '0px' }}>
                      <label style={{fontSize:'12px'}} for="firstname"> First Name*   </label>
                      <label style={{ paddingLeft: "100px" ,fontSize:'12px'}} for="lastname">Last Name</label>
                      <label style={{ paddingLeft: "115px",fontSize:'12px' }} for="PassportNo">Passport No</label>
                    </div>
                    <div style={{marginTop:'10px'}}>

                      <input
                        type="text"
                        name="firstname"
                        id={i + 1}
                        value={(Companion.filter(com => (i + 1) === com.id).length ? Companion.filter(com => (i + 1) === com.id)[0] : {}).fname}
                        onChange={changeCom_Fname}
                        //placeholder="Enter First Name"
                        required
                      />


                      <input style={{ marginLeft: "30px" }}
                        type="text"
                        name="lastname"
                        id={i + 1}
                        value={(Companion.filter(com => (i + 1) === com.id).length ? Companion.filter(com => (i + 1) === com.id)[0] : {}).lname}
                        onChange={changeCom_Lname}
                        //placeholder="Enter Last Name"
                        required
                      />
                      <input style={{ marginLeft: "30px" }}
                        type="text"
                        name="Passportno"
                        id={i + 1}
                        value={(Companion.filter(com => (i + 1) === com.id).length ? Companion.filter(com => (i + 1) === com.id)[0] : {}).pass}

                        onChange={changeCom_Pass_No}
                        //placeholder="Enter Passport No"
                        required
                      />

                    </div>

                  </form>
                </fieldset>

              )
            }
            return listItems
          })()}
        </ul>

      </div>

      </Box>
      {/* <div className="CheckIn" style={{ textAlign: 'left',marginLeft:'10px',height:'60px', marginTop: '-5px', lineHeight: '.6' }}> */}
<div  style={{ marginTop:'30px',   display: "inline-block",marginLeft:'120px',  width: "10px",  verticalAlign: "top"}}>
        <fieldset>
          <form action="#" method="get">
          <TableContainer
      component={Paper}
      sx={{
         ml: "0px", // margin-left دقیق
        width: "fit-content",
        borderRadius: 2,
        boxShadow: 3,
        mt:1,
      //  mx: "auto", // وسط‌چین جدول
        overflowX: "hidden", // 👈 جلوگیری از اسکرول افقی
      }}
    >
      <Table  size="small" 
sx={{
  borderCollapse: "collapse",
  "& .MuiTableCell-root": {
    padding: "4px 8px",   // 👈 کمی فاصله بیشتر بین ستون‌ها
    fontSize: "11px",     // 👈 خواناتر
    border: "1px solid #ddd",
    textAlign: "center",
    
   
  },
}}
  >
        <TableHead  >
          <TableRow>
            {[
              "Description",
              "Gel ₾",
              "Doller $",
            ].map((head, idx) => (
              <TableCell key={idx} sx={headerStyle}  >
                {head}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          <TableRow  sx={{
                      "& .MuiTableCell-root": {
                        padding: "2px 4px !important",
                      //  height: "10px",
                        lineHeight: "20px",
                      }
                    }}>
        <TableCell sx={{ fontSize: "10px !important" , fontWeight: "bold", color: "#333"  }}>Price Room</TableCell>

            <TableCell sx={cellStyle}>{(Reserv_Price * Reserv_Rate).toFixed(2)}</TableCell>
            <TableCell sx={cellStyle}>{Reserv_Price}</TableCell>
            </TableRow>
            <TableRow  sx={{
                      "& .MuiTableCell-root": {
                        padding: "2px 4px !important",
                      //  height: "10px",
                        lineHeight: "20px",
                      }
                    }}>
            <TableCell  sx={{ fontSize: "10px !important" , fontWeight: "bold", color: "#333"  }}>Breakfast</TableCell>
            <TableCell sx={cellStyle}>{(Reserv_BreakfastAmount * Nights_No * Reserv_Rate).toFixed(2)}</TableCell>
            <TableCell sx={cellStyle}>{Reserv_BreakfastAmount * Nights_No}</TableCell>
            </TableRow>
            <TableRow  sx={{
                      "& .MuiTableCell-root": {
                        padding: "2px 4px !important",
                      //  height: "10px",
                        lineHeight: "20px",
                      }
                    }}>
            <TableCell  sx={{ fontSize: "10px !important" , fontWeight: "bold", color: "#333"  }}>Extra Bed</TableCell>

            <TableCell sx={cellStyle}>{(Reserv_ExtraAmount * Nights_No * Reserv_Rate).toFixed(2)}</TableCell>
            <TableCell sx={cellStyle}>{Reserv_ExtraAmount * Nights_No}</TableCell>
            </TableRow>
            <TableRow  sx={{
                      "& .MuiTableCell-root": {
                        padding: "2px 4px !important",
                      //  height: "10px",
                        lineHeight: "20px",
                      }
                    }}>
            <TableCell  sx={{ fontSize: "10px !important" , fontWeight: "bold", color: "#333"  }}>Other Cost</TableCell>

            <TableCell sx={cellStyle}  >
              <input
                style={{
                  width: "40px",
                  textAlign: "center",
                  padding: "2px",
                  borderRadius: "6px",
                  border: "1px solid #ccc",
                }}
                type="text"
                id="Other"
                value={Reserv_gelother}
                onChange={changeReserv_GelOther}
                required
              />
            </TableCell>

            <TableCell sx={cellStyle}  >
              <input
                style={{
                  width: "40px",
                  textAlign: "center",
                  borderRadius: "6px",
                  border: "1px solid #ccc",
                  padding: "1px",
                  height: "18px",    // اضافه کنید
                  fontSize: "0.8rem" // برای کوتاه شدن
                }}
                type="text"
                id="Other"
                value={Reserv_other}
                onChange={changeReserv_Other}
                required
              />
            </TableCell>
            </TableRow>
            <TableRow  sx={{ backgroundColor: "#ffe6e6",
                      "& .MuiTableCell-root": {
                        padding: "2px 4px !important",
                      //  height: "10px",
                        lineHeight: "20px",
                      }
                    }}>
            <TableCell  sx={{ fontSize: "10px !important" , fontWeight: "bold", color: "#333" }}>(Discount)</TableCell>


            <TableCell sx={cellStyle}>
              <input
                style={{
                  width: "40px",
                  textAlign: "center",
                  padding: "4px",
                  borderRadius: "6px",
                  border: "1px solid #ccc",
                }}
                type="text"
                id="Discount"
                value={Reserv_GelDiscount}
                onChange={changeReserv_GelDiscount}
                required
              />
            </TableCell>

            <TableCell sx={cellStyle}>
              <input
                style={{
                  width: "40px",
                  textAlign: "center",
                  borderRadius: "6px",
                  border: "1px solid #ccc",
                  padding: "1px",
                  height: "18px",    // اضافه کنید
                  fontSize: "0.8rem" // برای کو
                }}
                type="text"
                id="Discount"
                value={Reserv_Discount}
                onChange={changeReserv_Discount}
                required
              />
            </TableCell>
            </TableRow>
            <TableRow  sx={{
                      "& .MuiTableCell-root": {
                        padding: "2px 4px !important",
                      //  height: "10px",
                        lineHeight: "20px",
                      }
                    }}>
            <TableCell  sx={{  mt: 1,borderTop: "2px solid #888" ,backgroundColor: "#f7f7f7", fontSize: "10px !important" , fontWeight: "bold", color: "#333"  }}>Payable</TableCell>

            <TableCell sx={cellStyle}>{(Reserv_Account  * Reserv_Rate).toFixed(2)}</TableCell>
            <TableCell sx={cellStyle}>{Reserv_Account}</TableCell>
            </TableRow>
  
          <TableRow  sx={{
                      "& .MuiTableCell-root": {
                        padding: "2px 4px !important",
                      //  height: "10px",
                        lineHeight: "20px",
                      }
                    }}>
            <TableCell  sx={{ fontSize: "10px !important" , fontWeight: "bold", color: "#333"  }}>Debit Balance</TableCell>

            <TableCell sx={cellStyle}>{(Reserv_DebitBalance  * Reserv_Rate).toFixed(2)}</TableCell>
            <TableCell sx={cellStyle}>{Reserv_DebitBalance}</TableCell>
            </TableRow>
            <TableRow  sx={{
                      "& .MuiTableCell-root": {
                        padding: "2px 4px !important",
                      //  height: "10px",
                        lineHeight: "20px",
                      }
                    }}>
            <TableCell  sx={{ fontSize: "10px !important" , fontWeight: "bold", color: "#333"  }}>prepayment reserv</TableCell>

            <TableCell sx={cellStyle}  >
              <input
                style={{
                  width: "40px",
                  textAlign: "center",
                  padding: "2px",
                  borderRadius: "6px",
                  border: "1px solid #ccc",
                }}
                type="text"
                id="Other"
                value={Reserv_GelprepaymenReserv}
                disabled={rescheckinflag}
                onChange={changeReserv_GelprepaymenReserv}
                required
              />
            </TableCell>

            <TableCell sx={cellStyle}  >
              <input
                style={{
                  width: "40px",
                  textAlign: "center",
                  borderRadius: "6px",
                  border: "1px solid #ccc",
                  padding: "1px",
                  height: "18px",    // اضافه کنید
                  fontSize: "0.8rem" // برای کوتاه شدن
                }}
                type="text"
                id="Other"
                value={Reserv_prepaymenReserv}
                onChange={changeReserv_prepaymenReserv}
                disabled={rescheckinflag}
                required
              />
            </TableCell>
            </TableRow>
            <TableRow  sx={{backgroundColor: "#e8f4ff",
                      "& .MuiTableCell-root": {
                        padding: "2px 4px !important",
                      //  height: "10px",
                        lineHeight: "20px",
                      }
                    }}>
            <TableCell  sx={{ fontSize: "10px !important" , fontWeight: "bold", color: "#333"  }}>Settelment</TableCell>

            <TableCell sx={cellStyle}>{(Reserv_total  * Reserv_Rate).toFixed(2)}</TableCell>
            <TableCell sx={cellStyle}>{Reserv_total}</TableCell>
            </TableRow>
            {rescheckinflag && (
            <TableRow  sx={{backgroundColor: "#f7f7f7",
                      "& .MuiTableCell-root": {
                        padding: "2px 4px !important",
                      //  height: "10px",
                        lineHeight: "20px",
                      }
                    }}>
                
                      
            <TableCell  sx={{ fontSize: "12px !important" , fontWeight: "bold", color: "#333"  }}>(PerPayment)</TableCell>
            <TableCell  sx={{
    borderTop: "2px solid #999",   // خط جدا کننده
    mt: 1,
    "& .MuiTableCell-root": {
      padding: "3px 4px !important",
    }
  }}
>
              <input
                style={{
                  width: "40px",
                  textAlign: "center",
                  padding: "4px",
                  borderRadius: "6px",
                  border: "1px solid #ccc",
                }}
                type="text"
                id="prepayment"
                value={Reserv_gelprepayment}
                onChange={changeReserv_Gelprepayment}
                required
              />
            </TableCell>
   
            <TableCell sx={cellStyle}>
              <input
                style={{
                  width: "40px",
                  textAlign: "center",
                  borderRadius: "6px",
                  border: "1px solid #ccc",
                  padding: "1px",
                  height: "18px",    // اضافه کنید
                  fontSize: "0.8rem" // برای کو
                }}
                type="text"
                id="ptepayment"
                value={Reserv_prepayment}
                onChange={changeReserv_prepayment}
                required
              />
            </TableCell>
 
            
          </TableRow>
         )}
          {/* <TableRow>
          <TableCell sx={{ fontSize: "20px !important" , fontWeight: "bold", color: "#333"  }}>₾</TableCell>
            <TableCell sx={cellStyle}>{(Base_Price * Reserv_Rate).toFixed(2)}</TableCell>
            <TableCell sx={cellStyle}>*</TableCell>
            <TableCell sx={cellStyle}>{Nights_No}</TableCell>
            <TableCell sx={cellStyle}>=</TableCell>
            <TableCell sx={cellStyle}>{(Reserv_Price * Reserv_Rate).toFixed(2)}</TableCell>
            <TableCell sx={cellStyle}>+</TableCell>
            <TableCell sx={cellStyle}>{(Reserv_BreakfastAmount * Adults_No * Reserv_Rate).toFixed(2)}</TableCell>
            <TableCell sx={cellStyle}>+</TableCell>
            <TableCell sx={cellStyle}>{(Reserv_ExtraAmount * Nights_No * Reserv_Rate).toFixed(2)}</TableCell>
            <TableCell sx={cellStyle}>+</TableCell>

            <TableCell sx={cellStyle}  >
              <input
                style={{
                  width: "40px",
                  textAlign: "center",
                  padding: "2px",
                  borderRadius: "6px",
                  border: "1px solid #ccc",
                }}
                type="text"
                id="Other"
                value={Reserv_gelother}
                onChange={changeReserv_GelOther}
                required
              />
            </TableCell>

            <TableCell sx={cellStyle}>-</TableCell>

            <TableCell sx={cellStyle}>
              <input
                style={{
                  width: "40px",
                  textAlign: "center",
                  padding: "4px",
                  borderRadius: "6px",
                  border: "1px solid #ccc",
                }}
                type="text"
                id="Discount"
                value={Reserv_GelDiscount}
                onChange={changeReserv_GelDiscount}
                required
              />
            </TableCell>

            <TableCell sx={cellStyle}>-</TableCell>
            <TableCell sx={cellStyle}>
              <input
                style={{
                  width: "40px",
                  textAlign: "center",
                  padding: "4px",
                  borderRadius: "6px",
                  border: "1px solid #ccc",
                }}
                type="text"
                id="prepayment"
                value={Reserv_gelprepayment}
                onChange={changeReserv_Gelprepayment}
                required
              />
            </TableCell>
   
            <TableCell sx={cellStyle}>=</TableCell>
            <TableCell sx={cellStyle}>{(Reserv_Account * Reserv_Rate).toFixed(2)}</TableCell>
     
          </TableRow> */}
        </TableBody>
      </Table>
    </TableContainer>
        
   </form>
        </fieldset>
        </div>

       

        <LoadingOverlay isLoading={loading} text="Loading data..." />

      {/* </div> */}
 
  <div>

 {/* پاپ‌آپ بزرگ‌نمایی */}
  <Dialog open={open} onClose={handleClose} maxWidth="md">
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
            backgroundColor: "rgba(255,255,255,0.7)",
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent
          sx={{
            p: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "black",
          }}
        >
      <Box
            component="img"
            src={`https://lhapi.luxintrip.com/images/${imgURL}`}
            alt="passport-large"
            sx={{
              maxWidth: "100%",
              maxHeight: "85vh",
              borderRadius: 1,
            }}
          />
        </DialogContent>
      </Dialog>
  </div>
  <div>

  {/* <label for="Chekindate" style={{ fontSize:'12px'}} >  Chek in date* </label> */}
 {/* پاپ‌آپ بزرگ‌نمایی */}
 <Dialog
                open={changeroomflag}
                // onClose={() => setCosts(false)}
                onClose={(event, reason) => {
                    if (reason === "backdropClick") return; // ❌ جلوگیری از بستن با کلیک بیرون
                    setChangeRoomFlag(false); // ✅ بستن با سایر دلایل (مثلاً دکمه Exit)
                  }}
                PaperProps={{
                    sx: {
                        maxWidth: 350,
                        maxHeight: 350,
                        width: 350,
                        height: 350,
                        backgroundColor: '#F2F2F2'
                    },
                    component: 'form',
                    onSubmit: (event) => {
                        event.preventDefault();
                        // ZanNumb(false);
                    },
                }}
            >
                <DialogTitle style={{height:'10px'}}>Change Room</DialogTitle>
                <DialogContent>
                    <DialogContentText>

                    </DialogContentText>
                    <Box sx={{ display: "flex", alignItems: "center", marginTop:'10px' }}>
                 <label for="Chekindate" style={{ fontSize:'12px'}} >Chek in date* </label>
                    {/* <Cost permission={props.Mojavez}/> */}
                    <DatePicker
                style={{ height: "35px" ,marginLeft:'-55px'}}
                // inputClass={"rmdp-input "+ classes + " " + className}
                className={((window.innerWidth < 850) ? "rmdp-mobile " : "")}
                name="Checkindate"
                required={true}
                disabled={false}
                calendarPosition="bottom"
                format='YYYY-MM-DD'
                  minDate={Reserv_Checkindate}
                calendar={gregorian}
                //    locale={"en"}
                value={ChangeRoom_Checkindate}
                onChange={(e) => setChangeRoom_Checkindate(e)}
                range={false}
              //  rangeHover={range}
              />
                    {/* <MyTable /> */}
</Box>
                    <Box sx={{ display: "flex", alignItems: "center", marginTop:'10px' }}>
                    <label for="Chekindate" style={{ fontSize:'12px',marginLeft:'0px'}} > New Room No* </label>
                    <Select style={{ width: '150px', height: '30px', marginLeft: '-55px', backgroundColor: "rgb(225, 225, 198)" }}
                          labelId="demo-multiple-name-label"
                          id="demo-multiple-name"
                          disabled={false}
                          value={ChangeRoom_No}
                          onChange={changeRoom_No}
                          input={<OutlinedInput label="Name" />}
                      //   MenuProps={MenuProps}
                        >
                        <MenuItem value="0">
                          <em>None</em>
                        </MenuItem>
                        {RoomTypeData.map((dat) => (
                          <MenuItem key={dat.Room_No} value={dat.Room_No}>{dat.Room_No}</MenuItem>
                        ))}

              </Select>
        </Box>
        <Stack direction="row" spacing={1} style={{marginTop:'40px',alignItems:'center',justifyContent:'center' }}>
                        <Chip label="Change" color="primary" onClick={ HandelChangeRoom} sx={{ width: 150, cursor: 'pointer' }} />
                    </Stack>
                </DialogContent>
                <DialogActions    >
                    <Stack direction="row" spacing={1} style={{ paddingRight: '90px' }}>
                        <Chip label="Exit" color="primary" onClick={() => setChangeRoomFlag(false)} sx={{ width: 150, cursor: 'pointer' }} />
                    </Stack>


                </DialogActions>
            </Dialog>
  </div>
      {SetVoucher()}
      <Snackbar
        open={error}
        autoHideDuration={6000}
        onClose={() => setError(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >



       <Alert onClose={() => setError(false)}   variant="filled" severity={alertType ===0 ? 'error' : 'info'}> 
       {txtMessage}
        </Alert>
      </Snackbar>

    </div>


  );

})
export default Reservation;